var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.06,
    height: 13.048,
    viewBox: "0 0 13.06 13.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74733",
    "data-name": "Group 74733",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M45.1,42.683a2.109,2.109,0,0,1,.5-.035q3.471,0,6.942,0a1.379,1.379,0,0,1,1.1.588q.779,1.04,1.559,2.08a.862.862,0,0,1,.282.827v7.43a3.4,3.4,0,0,1-.041.733,1.755,1.755,0,0,1-.835,1.15,1.8,1.8,0,0,1-.91.237H44.622a3.1,3.1,0,0,1-.915-.072,1.753,1.753,0,0,1-1.217-1.282,2.934,2.934,0,0,1-.048-.706q0-3.761,0-7.522a1.044,1.044,0,0,1,.033-.437,1.106,1.106,0,0,1,.249-.36q.76-1.015,1.521-2.028a1.45,1.45,0,0,1,.852-.605m.28,1.271c-.325.435-.652.869-.977,1.3h9.132c-.325-.435-.652-.868-.977-1.3q-3.589,0-7.178,0m-1.63,2.616q0,3.672,0,7.345a.454.454,0,0,0,.237.422.886.886,0,0,0,.426.054h9.3a.448.448,0,0,0,.328-.12.565.565,0,0,0,.149-.418V46.569Z",
    transform: "translate(-42.436 -42.647)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M173.79,213.448a.73.73,0,0,1,.787-.05.632.632,0,0,1,.3.57q0,1.318,0,2.635c.336-.283.677-.562,1.013-.846a.594.594,0,0,1,.45-.133.663.663,0,0,1,.6.668.629.629,0,0,1-.225.47L174.97,218.2a1.068,1.068,0,0,1-1.014.276c-.159-.052-.255-.2-.379-.3-.557-.461-1.11-.926-1.666-1.388a.744.744,0,0,1-.27-.534.664.664,0,0,1,1.007-.537q.462.383.921.769c0-.841,0-1.683,0-2.524A.649.649,0,0,1,173.79,213.448Z",
    transform: "translate(-167.689 -208.088)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.25f185843606227ccd5a48734f27e0c3.svg";
export { ForwardRef as ReactComponent };